import SecureLS from "secure-ls";
export const ls = new SecureLS({ isCompression: true, encodingType: 'aes' });